<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1">

            <a-descriptions-item label="产品名称">{{form.productName}}</a-descriptions-item>
            <!-- <a-descriptions-item label="类型">
                <dict-render :dict-obj="dictObjs['loanType']" :text="form.creditType"></dict-render>
            </a-descriptions-item> -->
            <a-descriptions-item label="联系人">{{form.contact}}</a-descriptions-item>
            <a-descriptions-item label="联系电话">{{form.contactNumber}}</a-descriptions-item>
            <a-descriptions-item label="申请贷款额度（万元）">{{form.loanAmount}}</a-descriptions-item>
            <!-- <a-descriptions-item label="授信金额">{{form.creditAmount}}</a-descriptions-item>
            <a-descriptions-item label="贷款时间">{{form.loanTime}}</a-descriptions-item>
            <a-descriptions-item label="授信时间">
                <dict-render :dict-obj="dictObjs['guarantee']" :text="form.creditTime"></dict-render>
            </a-descriptions-item>
            <a-descriptions-item label="服务类型">
                <a-tag v-if="record.type == '0'">线下</a-tag>
                <a-tag v-if="record.type == '1'">线上</a-tag>
            </a-descriptions-item> -->
            <a-descriptions-item label="申请备注">{{form.applicationRemarks}}</a-descriptions-item>

        </a-descriptions>
    </a-modal>
</template>

<script>
import {
        dictMixin,formMixin } from "@/mixins";
// import DictRender from "@/components/other/DictRender";

export default {
    name: "Detail",
    mixins: [
        dictMixin,formMixin],
    // components:{DictRender},
    data() {
        return {
            dictNames: 'loanType,aduit_status',
            form: {
                id: null,
                productName: null,
                companyCode: null,
                loanAmount: null,
                creditAmount: null,
                loanTime: null,
                creditTime: null,
                type: null,
                contact: null,
                contactNumber: null,
                applicationRemarks: null,
                creditType: null,
            },
        }
    },
    methods:{
        onClose(){
            this.visible = false
            this.$emit("onCloseModel")
        }
    }
}
</script>

<style scoped lang="less">

</style>
